/**
 * 字典工厂
 */
export default class DictionaryFactory {

    constructor({name}) {
        this.name = name;
    }

    async getDictionary() {
        return null;
    }
}